import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
	selectEmail,
	selectSuccess,
	selectValidity,
	sendAPIRequest,
	selectUserUuid,
	selectUserName,
	selectPaymentSettingsStatus,
} from '../../store/signup';
import { useNavigate } from 'react-router-dom';
import { selectEventsData } from '../../store/events';
import { useStickyButtonStyles } from '../../hooks/useStickyButtonStyles';
import { EVENTS } from '../../analytics/events';
import { sendAnalyticsEvents } from '../../analytics/common';
import { AppButton, AppDescription, AppHeaderLogo, AppHeadline } from '../../components';
import SignupInput from './SignupInput';
import styled from 'styled-components';
import { selectLandingType } from '../../store/plans';
import { setAmplitudeUserProperties } from '../../analytics/amplitude';

const TextWrapper = styled.div`
	max-width: 327px;
	margin-bottom: 40px;
	@media screen and (max-width: 450px) {
		margin-bottom: 0;
	}
`;

const SignupScreen = () => {
	const { t } = useTranslation();
	const isValid = useSelector(selectValidity);
	const email = useSelector(selectEmail);
	const userUuid = useSelector(selectUserUuid);
	const name = useSelector(selectUserName);
	const isSuccess = useSelector(selectSuccess);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const eventsData = useSelector(selectEventsData);
	const [initEventSent, setInitEventStatus] = useState(false);
	const { stickyButtonStyles } = useStickyButtonStyles();
	const landingType = useSelector(selectLandingType);
	const isIntroOffer = landingType === 'intro_offer';
  const isTriviaFlow = landingType === 'trivia';
	const settingsStatus = useSelector(selectPaymentSettingsStatus);

	const onBtnClick = () => {
		window?.ttq?.track('Contact', {});
		sendAnalyticsEvents(EVENTS.onboardingEnterEmailSubmitted, eventsData);
		dispatch(sendAPIRequest({ email, name, landingType, userUuid }));
	};

	useEffect(() => {
		if (initEventSent) return;
		sendAnalyticsEvents(EVENTS.onboardingEnterEmailShown, eventsData);
		setInitEventStatus(true);
	}, [initEventSent, eventsData]);

	useLayoutEffect(() => {
		if (isSuccess && settingsStatus) {
			window?.ttq?.track('CompleteRegistration', {});
			window?.pintrk?.('track', 'signup');
			setAmplitudeUserProperties({ email });
			sendAnalyticsEvents(EVENTS.signupSuccess, eventsData);
			navigate(
        isIntroOffer
          ? '/checkout'
          : isTriviaFlow
            ? '/trivia-score'
            : '/creating-profile'
      );
		}
	}, [isSuccess, navigate, eventsData, isIntroOffer, settingsStatus, isTriviaFlow, email]);

	return (
		<>
			{isIntroOffer && <AppHeaderLogo />}
			<TextWrapper>
        <AppHeadline customStyles={isTriviaFlow ? 'margin: 20px 0 8px': 'margin: 0px 0px 8px'}>
					{t('whats_your_email')}
				</AppHeadline>
				<AppDescription customMargin={'0 0 32px 0'}>
					{t('email_description')}
				</AppDescription>
				<SignupInput />
			</TextWrapper>
			<AppButton
				onClick={onBtnClick}
				disabled={!isValid}
				stickyProps={stickyButtonStyles}
				bottomPosition={'16px'}
				customStyles={`${isIntroOffer && 'min-height: 56px;'}`}
			/>
		</>
	);
};

export default SignupScreen;
